import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAdminsFunc } from "../../../store/custom-actions/admins-actions/GetAdminsSlicer";

const SUBJECT_TYPES = [
  "product",
  "order",
  "category",
  "coupon",
  "user",
  "admin",
  "contact",
  "slider",
  "attribute",
  "attribute_value",
  "country",
  "state",
  "city",
  "language",
  "currency",
  "partner",
  "newsletter",
  "upload",
  "role",
];

export default function ActivityLogFilterModal({
  show,
  onHide,
  filters,
  onChange,
  onApply,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: adminsList } = useSelector((state) => state.getAdminsSlicer);

  useEffect(() => {
    if (show && !adminsList?.length) {
      dispatch(getAdminsFunc());
    }
  }, [show, adminsList?.length, dispatch]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t("Filter Activity Logs")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="form-group col-md-6">
            <label>{t("Admin (Causer)")}</label>
            <select
              className="form-control"
              name="causer_id"
              value={filters.causer_id}
              onChange={onChange}
            >
              <option value="">{t("All")}</option>
              {adminsList?.map((admin) => (
                <option key={admin.id} value={admin.id}>
                  {admin.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-6">
            <label>{t("Subject Type")}</label>
            <select
              className="form-control"
              name="subject_type"
              value={filters.subject_type}
              onChange={onChange}
            >
              <option value="">{t("All")}</option>
              {SUBJECT_TYPES.map((type) => (
                <option key={type} value={type}>
                  {t(type)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label>{t("Subject ID")}</label>
            <input
              type="number"
              className="form-control"
              name="subject_id"
              placeholder={t("e.g. 1")}
              value={filters.subject_id}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label>{t("Date From")}</label>
            <input
              type="date"
              className="form-control"
              name="date_from"
              value={filters.date_from}
              onChange={onChange}
            />
          </div>
          <div className="form-group col-md-6">
            <label>{t("Date To")}</label>
            <input
              type="date"
              className="form-control"
              name="date_to"
              value={filters.date_to}
              onChange={onChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onHide}>
          {t("Cancel")}
        </button>
        <button type="button" className="btn btn-primary" onClick={onApply}>
          {t("Apply Filters")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
